module.exports = "/_next/static/images/1-493e54898942c1918249473b8a76cbbb.png.webp";